// frontend/src/i18n/translations.js

export const translations = {
    en: {
        // ============================================
        // Common
        // ============================================
        'common.loading': 'Loading...',
        'common.continue': 'Continue',
        'common.submit': 'Submit',
        'common.next': 'Next',
        'common.back': 'Back',
        'common.cancel': 'Cancel',
        'common.retry': 'Retry',
        'common.yes': 'Yes',
        'common.no': 'No',
        'common.optional': 'Optional',
        'common.required': 'Required',
        'common.error': 'Error',
        'common.success': 'Success',

        // ============================================
        // Phone Verification
        // ============================================
        'verify.title': 'Verify Your Identity',
        'verify.subtitle': 'Please provide your contact details to continue',
        'verify.phone_label': 'Phone Number',
        'verify.phone_placeholder': 'Enter 10-digit phone number',
        'verify.phone_hint': 'Enter your 10-digit phone number for verification',
        'verify.aadhar_label': 'Aadhar Number',
        'verify.aadhar_placeholder': 'Enter 12-digit Aadhar number',
        'verify.aadhar_hint': 'Enter your 12-digit Aadhar number for verification',
        'verify.name_label': 'Full Name',
        'verify.name_placeholder': 'Enter your full name',
        'verify.age_label': 'Age',
        'verify.age_placeholder': 'Enter your age',
        'verify.sex_label': 'Sex',
        'verify.sex_male': 'Male',
        'verify.sex_female': 'Female',
        'verify.sex_other': 'Other',
        'verify.submit': 'Verify & Continue',
        'verify.submitting': 'Verifying...',
        'verify.redirecting': 'Redirecting...',
        'verify.standard_link_notice': 'This is a standard link. Multiple candidates can use it.',
        'verify.standard_link_notice2': 'Each candidate will get their own unique assessment.',
        'verify.privacy_notice': 'Your phone number is only used for verification purposes.',
        'verify.one_time_notice': 'This link is valid for one-time use per candidate.',
        'verify.error_title': 'Verification Failed',
        'verify.error_phone': 'Please enter a valid 10-digit phone number',
        'verify.error_aadhar': 'Please enter a valid 12-digit Aadhar number',
        'verify.error_invalid_link': 'Invalid or expired verification link',
        'verify.already_completed_title': 'Assessment Already Completed',
        'verify.already_completed_message': 'You have already completed this assessment. Your responses have been recorded.',
        'verify.resuming_title': 'Resuming Your Session',
        'verify.resuming_message': 'Welcome back! Continuing from where you left off...',
        'verify.view_result': 'View Summary',

        // ============================================
        // Demographics Form
        // ============================================
        'demo.title': 'Personal Information',
        'demo.subtitle': 'Please fill in your details to continue',
        'demo.submit': 'Continue',
        'demo.submitting': 'Submitting...',
        'demo.required_missing': 'Please fill all required fields',

        // Field Labels (Fallback if not from DB)
        'demo.field.full_name': 'Full Name',
        'demo.field.date_of_birth': 'Date of Birth',
        'demo.field.education': 'Education',
        'demo.field.sex': 'Sex',
        'demo.field.address': 'Address',
        'demo.field.email': 'Email',
        'demo.field.phone': 'Phone',
        'demo.field.job_position': 'Job Position',
        'demo.field.department': 'Department',
        'demo.field.passport_no': 'Passport Number',
        'demo.field.data_usage_consent': 'Data Usage Consent',

        // ============================================
        // Sample Video Page
        // ============================================
        'video.title': 'Instructions',
        'video.subtitle': 'Watch this sample video to understand the assessment format',
        'video.description': 'Please watch the following video carefully. It explains the assessment process and what to expect.',
        'video.watched': 'Instructions watched!',
        'video.watch_prompt': 'Watch the video to continue',
        'video.continue': 'Continue to Assessment',
        'video.no_video': 'No instructions video available.',
        'video.drive_error': 'Video failed to load. Please check your internet connection.',
        'video.progress': 'watched',

        'test.already_ranked_all': '✅ You have already ranked all 4 options!',
        'test.already_selected_this_order': 'You already selected for {ordinal} choice',
        'test.error_saving': 'Error saving selection. Please try again.',
        'test.no_options': 'No response options available for this item',
        'test.video_title': 'Assessment Video',

        // ============================================
        // Photo Capture
        // ============================================
        'photo.title_before': 'Take Your Photo',
        'photo.title_middle': 'Mid-Assessment Photo',
        'photo.title_end': 'Final Photo',
        'photo.subtitle_before': 'Please take a photo before starting the assessment',
        'photo.subtitle_middle': 'Please take a photo to continue the assessment',
        'photo.subtitle_end': 'Please take a final photo before submitting',
        'photo.camera_error': 'Unable to access camera. Please allow camera access and try again.',
        'photo.camera_not_ready': 'Camera is not ready. Please wait.',
        'photo.captured_success': 'Face photo captured successfully!',
        'photo.capture_failed': 'Failed to capture photo',
        'photo.loading_camera': 'Loading camera...',
        'photo.smile': 'Smile!',
        'photo.captured_badge': 'Captured',
        'photo.take_photo': 'Take Photo',
        'photo.taking_photo': 'Taking Photo...',
        'photo.retry_camera': 'Retry Camera',
        'photo.retake_photo': 'Retake Photo',
        'photo.save_photo': 'Save Photo',
        'photo.saving': 'Saving...',
        'photo.tips_title': 'Tips:',
        'photo.tip_face_visible': 'Make sure your face is clearly visible',
        'photo.tip_look_camera': 'Look directly at the camera',
        'photo.tip_countdown': 'A 3-second countdown will start when you click "Take Photo"',
        'photo.camera_permission_denied': 'Camera access was denied. Please enable camera permission in your browser settings and try again.',
        'photo.camera_not_found': 'No camera found on this device. Please connect a camera and try again.',
        'photo.camera_in_use': 'Camera is already in use by another application. Please close other apps and try again.',
        'photo.camera_constraints': 'Camera does not meet the required constraints. Please try a different device.',
        'photo.camera_insecure': 'Camera requires a secure connection (HTTPS). Please access this page over HTTPS.',
        'photo.camera_not_supported': 'Camera not supported. Please use a modern browser over HTTPS.',
        'photo.permission_blocked_title': 'Camera Access Blocked',
        'photo.permission_blocked_message': 'You have denied camera access. To continue with this verification step, please enable camera permission in your browser settings.',
        'photo.how_to_enable': 'How to enable:',
        'photo.enable_step_1': "Click the lock/settings icon in your browser's address bar",
        'photo.enable_step_2': 'Set Camera permission to "Allow"',
        'photo.enable_step_3': 'Refresh this page to continue',
        'photo.refresh_page': 'Refresh Page',
        'photo.try_again': 'Try Again',
        'photo.camera_unavailable_title': 'Camera Unavailable',
        'photo.camera_unavailable_message': 'This device or browser does not support camera access. Please try a different device or a modern browser.',

        // ============================================
        // Test Page
        // ============================================
        'test.assessment_name': 'EBCSS (Video)',
        'test.resumed': 'Resumed',
        'test.progress': 'Question {current} of {total}',
        'test.answered_count': '{answered} of {total} answered',
        'test.instruction_rank': 'Watch the video carefully. Select your {ordinal} choice',
        'test.rank_1st': '1st',
        'test.rank_2nd': '2nd',
        'test.rank_3rd': '3rd',
        'test.rank_4th': '4th',
        'test.ranking_progress': 'Ranking Progress',
        'test.all_ranked': 'All 4 options ranked!',
        'test.already_selected': 'Already selected as {ordinal} choice',
        'test.please_answer': 'Please answer this question before proceeding.',
        'test.please_answer_all': 'Please answer all questions before submitting.',
        'test.unanswered': '{count} remaining',
        'test.submit': 'Submit Assessment',
        'test.submitting': 'Submitting...',
        'test.stay_on_tab': 'Stay on this tab during the assessment',
        'test.photo_capturing': 'Taking photo...',
        'test.photo_captured': 'Photo captured',
        'test.photo_error': 'Could not capture photo',
        'test.please_answer': 'Please answer this question before proceeding.',
        'test.please_answer_all': 'Please answer all questions before submitting.',
        'test.unanswered': 'remaining',
        'test.stay_on_tab': 'Stay on this tab during the assessment',
        'test.taking_photo': 'Taking verification photo...',
        'test.image_unavailable': 'Image not available',
        'test.cpm_instruction': 'Select the option that completes the pattern',
        'test.assessment_name_ebcss': 'EBCSS (Video)',
        'test.reset': 'Reset',
        'test.resetting': 'Resetting...',
        'test.reset_tooltip': 'Reset all selections for this question',
        'test.confirm_reset': 'Reset all rankings for this question?',
        'test.reset_success': 'Selections reset!',
        'test.reset_error': 'Failed to reset selections',
        'test.nothing_to_reset': 'No selections to reset',

        // ============================================
        // Result / Thank You Page
        // ============================================
        'result.title': 'Thank You!',
        'result.subtitle': 'Your assessment has been submitted successfully',
        'result.message': 'Your responses have been recorded. The assessment team will review your submission.',
        'result.what_next': 'What happens next?',
        'result.next_step_1': 'Your responses will be analyzed',
        'result.next_step_2': 'The assessment team will review your results',
        'result.next_step_3': 'You will be contacted with next steps',
        'result.close': 'Close',
        'result.reference': 'Reference ID: {id}',
        'result.contact': 'If you have any questions, please contact the assessment team.',

        // ============================================
        'error.PHONE_REQUIRED': 'Phone number is required',
        'error.PHONE_INVALID': 'Please enter a valid 10-digit phone number',
        'error.AADHAR_REQUIRED': 'Aadhar number is required',
        'error.AADHAR_INVALID': 'Please enter a valid 12-digit Aadhar number',
        'error.INVALID_TOKEN': 'Invalid or expired verification link',
        'error.AADHAR_IN_USE': 'This Aadhar number is already registered for an active assessment',
        'error.PHONE_IN_USE': 'This phone number is already registered for an active assessment',
        'error.SERVER_ERROR': 'Something went wrong. Please try again.',

        // ============================================
        // Verification Page — Error Headers
        // ============================================
        'verify.failed_title': 'Verification Failed',
        'verify.duplicate_title': 'Phone number / Aadhar already in use',
        'verify.try_again': 'Try Again',

        // ============================================
        // Face Verification (Extended)
        // ============================================
        'faceverify.camera_access_error': 'Unable to access camera. Please allow camera access.',
        'faceverify.pause_default_reason': 'Face verification failed',
        'faceverify.verify_error_retry': 'Face verification failed. Please try again.',
        'faceverify.skipped': 'Verification Skipped',
        'faceverify.test_in_progress': 'Test in progress',
        'faceverify.verifying': 'Verifying...',
        'faceverify.verify_face': 'Verify Face',
        'faceverify.verify_failed': 'Face verification failed',
        'faceverify.try_again': 'Try Again',
        'faceverify.paused_title': 'Test Paused',
        'faceverify.paused_message': 'Face verification failed. Please ensure you are the registered candidate.',
        'faceverify.auto_resume': 'The test will resume automatically',
        'faceverify.resume_now': 'Resume Now',
        'faceverify.verified': 'Face Verified',

        'test.auto_submitting_in': 'Submitting in',
        'test.all_answered': 'All questions answered',
        'test.submit_now': 'Submit Now',
        'test.submit_error': 'Failed to submit assessment. Please try again.',

    },

    kn: {
        // ============================================
        // Common
        // ============================================
        'common.loading': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
        'common.continue': 'ಮುಂದುವರಿಸಿ',
        'common.submit': 'ಸಲ್ಲಿಸಿ',
        'common.next': 'ಮುಂದೆ',
        'common.back': 'ಹಿಂದೆ',
        'common.cancel': 'ರದ್ದುಮಾಡಿ',
        'common.retry': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        'common.yes': 'ಹೌದು',
        'common.no': 'ಇಲ್ಲ',
        'common.optional': 'ಐಚ್ಛಿಕ',
        'common.required': 'ಕಡ್ಡಾಯ',
        'common.error': 'ದೋಷ',
        'common.success': 'ಯಶಸ್ಸು',

        // ============================================
        // Phone Verification
        // ============================================
        'verify.title': 'ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸಿ',
        'verify.subtitle': 'ಮುಂದುವರಿಯಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸಂಪರ್ಕ ವಿವರಗಳನ್ನು ಒದಗಿಸಿ',
        'verify.phone_label': 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
        'verify.phone_placeholder': '10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'verify.phone_hint': 'ಪರಿಶೀಲನೆಗಾಗಿ ನಿಮ್ಮ 10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'verify.aadhar_label': 'ಆಧಾರ್ ಸಂಖ್ಯೆ',
        'verify.aadhar_placeholder': '12-ಅಂಕಿಯ ಆಧಾರ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'verify.aadhar_hint': 'ಪರಿಶೀಲನೆಗಾಗಿ ನಿಮ್ಮ 12-ಅಂಕಿಯ ಆಧಾರ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'verify.name_label': 'ಪೂರ್ಣ ಹೆಸರು',
        'verify.name_placeholder': 'ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
        'verify.age_label': 'ವಯಸ್ಸು',
        'verify.age_placeholder': 'ನಿಮ್ಮ ವಯಸ್ಸನ್ನು ನಮೂದಿಸಿ',
        'verify.sex_label': 'ಲಿಂಗ',
        'verify.sex_male': 'ಪುರುಷ',
        'verify.sex_female': 'ಮಹಿಳೆ',
        'verify.sex_other': 'ಇತರೆ',
        'verify.submit': 'ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಮುಂದುವರಿಸಿ',
        'verify.submitting': 'ಪರಿಶೀಲಿಸುತ್ತಿದೆ...',
        'verify.redirecting': 'ಮರುನಿರ್ದೇಶಿಸುತ್ತಿದೆ...',
        'verify.standard_link_notice': 'ಇದು ಪ್ರಮಾಣಿತ ಲಿಂಕ್ ಆಗಿದೆ. ಅನೇಕ ಅಭ್ಯರ್ಥಿಗಳು ಇದನ್ನು ಬಳಸಬಹುದು.',
        'verify.standard_link_notice2': 'ಪ್ರತಿ ಅಭ್ಯರ್ಥಿಗೂ ತಮ್ಮದೇ ಆದ ವಿಶಿಷ್ಟ ಮೌಲ್ಯಮಾಪನ ಸಿಗುತ್ತದೆ.',
        'verify.privacy_notice': 'ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲನಾ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಮಾತ್ರ ಬಳಸಲಾಗುತ್ತದೆ.',
        'verify.one_time_notice': 'ಈ ಲಿಂಕ್ ಪ್ರತಿ ಅಭ್ಯರ್ಥಿಗೆ ಒಂದು ಬಾರಿ ಬಳಕೆಗೆ ಮಾನ್ಯವಾಗಿದೆ.',
        'verify.error_title': 'ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ',
        'verify.error_phone': 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ 10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'verify.error_aadhar': 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ 12-ಅಂಕಿಯ ಆಧಾರ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'verify.error_invalid_link': 'ಅಮಾನ್ಯ ಅಥವಾ ಅವಧಿ ಮುಗಿದ ಪರಿಶೀಲನಾ ಲಿಂಕ್',
        'verify.already_completed_title': 'ಮೌಲ್ಯಮಾಪನ ಈಗಾಗಲೇ ಪೂರ್ಣಗೊಂಡಿದೆ',
        'verify.already_completed_message': 'ನೀವು ಈಗಾಗಲೇ ಈ ಮೌಲ್ಯಮಾಪನವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ದೀರಿ. ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಳನ್ನು ದಾಖಲಿಸಲಾಗಿದೆ.',
        'verify.resuming_title': 'ನಿಮ್ಮ ಅವಧಿಯನ್ನು ಮುಂದುವರಿಸಲಾಗುತ್ತಿದೆ',
        'verify.resuming_message': 'ಮತ್ತೆ ಸ್ವಾಗತ! ನೀವು ನಿಲ್ಲಿಸಿದ ಸ್ಥಳದಿಂದ ಮುಂದುವರಿಯುತ್ತಿದೆ...',
        'verify.view_result': 'ಸಾರಾಂಶ ವೀಕ್ಷಿಸಿ',

        // ============================================
        // Demographics Form
        // ============================================
        'demo.title': 'ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ',
        'demo.subtitle': 'ಮುಂದುವರಿಯಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        'demo.submit': 'ಮುಂದುವರಿಸಿ',
        'demo.submitting': 'ಸಲ್ಲಿಸುತ್ತಿದೆ...',
        'demo.required_missing': 'ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಕಡ್ಡಾಯ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ',

        // Field Labels (Kannada)
        'demo.field.full_name': 'ಪೂರ್ಣ ಹೆಸರು',
        'demo.field.date_of_birth': 'ಹುಟ್ಟಿದ ದಿನಾಂಕ',
        'demo.field.education': 'ಶಿಕ್ಷಣ',
        'demo.field.sex': 'ಲಿಂಗ',
        'demo.field.address': 'ವಿಳಾಸ',
        'demo.field.email': 'ಇಮೇಲ್',
        'demo.field.phone': 'ಮೊಬೈಲ್',
        'demo.field.job_position': 'ಉದ್ಯೋಗ ಸ್ಥಾನ',
        'demo.field.department': 'ಇಲಾಖೆ',
        'demo.field.passport_no': 'ಪಾಸ್ಪೋರ್ಟ್ ಸಂಖ್ಯೆ',
        'demo.field.data_usage_consent': 'ಡೇಟಾ ಬಳಕೆ ಸಮ್ಮತಿ',

        // ============================================
        // Sample Video Page
        // ============================================
        'video.title': 'ಸೂಚನೆಗಳು',
        'video.subtitle': 'ಮೌಲ್ಯಮಾಪನ ಸ್ವರೂಪವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಈ ಮಾದರಿ ವೀಡಿಯೊವನ್ನು ವೀಕ್ಷಿಸಿ',
        'video.description': 'ದಯವಿಟ್ಟು ಈ ಕೆಳಗಿನ ವೀಡಿಯೊವನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ವೀಕ್ಷಿಸಿ. ಇದು ಮೌಲ್ಯಮಾಪನ ಪ್ರಕ್ರಿಯೆ ಮತ್ತು ಏನನ್ನು ನಿರೀಕ್ಷಿಸಬೇಕು ಎಂಬುದನ್ನು ವಿವರಿಸುತ್ತದೆ.',
        'video.watched': 'ಸೂಚನೆಗಳನ್ನು ವೀಕ್ಷಿಸಲಾಗಿದೆ!',
        'video.watch_prompt': 'ಮುಂದುವರಿಯಲು ವೀಡಿಯೊವನ್ನು ವೀಕ್ಷಿಸಿ',
        'video.continue': 'ಮೌಲ್ಯಮಾಪನಕ್ಕೆ ಮುಂದುವರಿಸಿ',
        'video.no_video': 'ಯಾವುದೇ ಸೂಚನಾ ವೀಡಿಯೊ ಲಭ್ಯವಿಲ್ಲ.',
        'video.drive_error': 'ವೀಡಿಯೊ ಲೋಡ್ ಆಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕವನ್ನು ಪರಿಶೀಲಿಸಿ.',
        'video.progress': 'ವೀಕ್ಷಿಸಲಾಗಿದೆ',

        'test.already_ranked_all': '✅ ನೀವು ಈಗಾಗಲೇ ಎಲ್ಲಾ 4 ಆಯ್ಕೆಗಳನ್ನು ಶ್ರೇಣೀಕರಿಸಿದ್ದೀರಿ!',
        'test.already_selected_this_order': '{ordinal} ಆಯ್ಕೆಗೆ ನೀವು ಈಗಾಗಲೇ ಆಯ್ಕೆ ಮಾಡಿದ್ದೀರಿ',
        'test.error_saving': 'ಆಯ್ಕೆಯನ್ನು ಉಳಿಸುವಲ್ಲಿ ದೋಷ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'test.no_options': 'ಈ ಐಟಂಗೆ ಯಾವುದೇ ಪ್ರತಿಕ್ರಿಯೆ ಆಯ್ಕೆಗಳು ಲಭ್ಯವಿಲ್ಲ',
        'test.video_title': 'ಮೌಲ್ಯಮಾಪನ ವೀಡಿಯೊ',

        // ============================================
        // Photo Capture (Kannada)
        // ============================================
        'photo.title_before': 'ನಿಮ್ಮ ಫೋಟೋ ತೆಗೆಯಿರಿ',
        'photo.title_middle': 'ಮಧ್ಯ-ಮೌಲ್ಯಮಾಪನ ಫೋಟೋ',
        'photo.title_end': 'ಅಂತಿಮ ಫೋಟೋ',
        'photo.subtitle_before': 'ಮೌಲ್ಯಮಾಪನ ಪ್ರಾರಂಭಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು ಫೋಟೋ ತೆಗೆಯಿರಿ',
        'photo.subtitle_middle': 'ಮೌಲ್ಯಮಾಪನ ಮುಂದುವರಿಸಲು ದಯವಿಟ್ಟು ಫೋಟೋ ತೆಗೆಯಿರಿ',
        'photo.subtitle_end': 'ಸಲ್ಲಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು ಅಂತಿಮ ಫೋಟೋ ತೆಗೆಯಿರಿ',
        'photo.camera_error': 'ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ. ದಯವಿಟ್ಟು ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'photo.camera_not_ready': 'ಕ್ಯಾಮೆರಾ ಸಿದ್ಧವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಕಾಯಿರಿ.',
        'photo.captured_success': 'ಮುಖದ ಫೋಟೋ ಯಶಸ್ವಿಯಾಗಿ ತೆಗೆಯಲಾಗಿದೆ!',
        'photo.capture_failed': 'ಫೋಟೋ ತೆಗೆಯಲು ವಿಫಲವಾಗಿದೆ',
        'photo.loading_camera': 'ಕ್ಯಾಮೆರಾ ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
        'photo.smile': 'ಕಿರುನಗೆ ಮಾಡಿ!',
        'photo.captured_badge': 'ತೆಗೆಯಲಾಗಿದೆ',
        'photo.take_photo': 'ಫೋಟೋ ತೆಗೆಯಿರಿ',
        'photo.taking_photo': 'ಫೋಟೋ ತೆಗೆಯಲಾಗುತ್ತಿದೆ...',
        'photo.retry_camera': 'ಕ್ಯಾಮೆರಾ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        'photo.retake_photo': 'ಫೋಟೋ ಮತ್ತೆ ತೆಗೆಯಿರಿ',
        'photo.save_photo': 'ಫೋಟೋ ಉಳಿಸಿ',
        'photo.saving': 'ಉಳಿಸುತ್ತಿದೆ...',
        'photo.tips_title': 'ಸಲಹೆಗಳು:',
        'photo.tip_face_visible': 'ನಿಮ್ಮ ಮುಖವು ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣುವಂತೆ ಮಾಡಿ',
        'photo.tip_look_camera': 'ನೇರವಾಗಿ ಕ್ಯಾಮೆರಾದತ್ತ ನೋಡಿ',
        'photo.tip_countdown': '"ಫೋಟೋ ತೆಗೆಯಿರಿ" ಕ್ಲಿಕ್ ಮಾಡಿದಾಗ 3-ಸೆಕೆಂಡ್ ಕೌಂಟ್ಡೌನ್ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ',
        'photo.camera_permission_denied': 'ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ನಿರಾಕರಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್ಗಳಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಅನುಮತಿಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'photo.camera_not_found': 'ಈ ಸಾಧನದಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಕಂಡುಬಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ಕ್ಯಾಮೆರಾವನ್ನು ಸಂಪರ್ಕಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'photo.camera_in_use': 'ಕ್ಯಾಮೆರಾವನ್ನು ಈಗಾಗಲೇ ಇನ್ನೊಂದು ಅಪ್ಲಿಕೇಶನ್ ಬಳಸುತ್ತಿದೆ. ದಯವಿಟ್ಟು ಇತರ ಅಪ್ಲಿಕೇಶನ್ಗಳನ್ನು ಮುಚ್ಚಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'photo.camera_constraints': 'ಕ್ಯಾಮೆರಾ ಅಗತ್ಯವಿರುವ ನಿರ್ಬಂಧಗಳನ್ನು ಪೂರೈಸುತ್ತಿಲ್ಲ. ದಯವಿಟ್ಟು ಬೇರೆ ಸಾಧನವನ್ನು ಪ್ರಯತ್ನಿಸಿ.',
        'photo.camera_insecure': 'ಕ್ಯಾಮೆರಾಗೆ ಸುರಕ್ಷಿತ ಸಂಪರ್ಕ (HTTPS) ಅಗತ್ಯವಿದೆ. ದಯವಿಟ್ಟು ಈ ಪುಟವನ್ನು HTTPS ಮೂಲಕ ಪ್ರವೇಶಿಸಿ.',
        'photo.camera_not_supported': 'ಕ್ಯಾಮೆರಾ ಬೆಂಬಲಿತವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು HTTPS ಮೂಲಕ ಆಧುನಿಕ ಬ್ರೌಸರ್ ಬಳಸಿ.',
        'photo.permission_blocked_title': 'ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶ ನಿರ್ಬಂಧಿಸಲಾಗಿದೆ',
        'photo.permission_blocked_message': 'ನೀವು ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ನಿರಾಕರಿಸಿದ್ದೀರಿ. ಈ ಪರಿಶೀಲನಾ ಹಂತವನ್ನು ಮುಂದುವರಿಸಲು, ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್ಗಳಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಅನುಮತಿಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ.',
        'photo.how_to_enable': 'ಹೇಗೆ ಸಕ್ರಿಯಗೊಳಿಸುವುದು:',
        'photo.enable_step_1': 'ನಿಮ್ಮ ಬ್ರೌಸರ್ನ ವಿಳಾಸ ಪಟ್ಟಿಯಲ್ಲಿ ಲಾಕ್/ಸೆಟ್ಟಿಂಗ್ಸ್ ಐಕಾನ್ ಕ್ಲಿಕ್ ಮಾಡಿ',
        'photo.enable_step_2': 'ಕ್ಯಾಮೆರಾ ಅನುಮತಿಯನ್ನು "ಅನುಮತಿಸಿ" ಎಂದು ಹೊಂದಿಸಿ',
        'photo.enable_step_3': 'ಮುಂದುವರಿಯಲು ಈ ಪುಟವನ್ನು ರಿಫ್ರೆಶ್ ಮಾಡಿ',
        'photo.refresh_page': 'ಪುಟ ರಿಫ್ರೆಶ್ ಮಾಡಿ',
        'photo.try_again': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        'photo.camera_unavailable_title': 'ಕ್ಯಾಮೆರಾ ಲಭ್ಯವಿಲ್ಲ',
        'photo.camera_unavailable_message': 'ಈ ಸಾಧನ ಅಥವಾ ಬ್ರೌಸರ್ ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಬೆಂಬಲಿಸುವುದಿಲ್ಲ. ದಯವಿಟ್ಟು ಬೇರೆ ಸಾಧನ ಅಥವಾ ಆಧುನಿಕ ಬ್ರೌಸರ್ ಪ್ರಯತ್ನಿಸಿ.',

        // ============================================
        // Test Page
        // ============================================
        'test.assessment_name': 'EBCSS (ವೀಡಿಯೊ)',
        'test.resumed': 'ಮುಂದುವರಿಸಲಾಗಿದೆ',
        'test.progress': 'ಪ್ರಶ್ನೆ {current} / {total}',
        'test.answered_count': '{answered} / {total} ಉತ್ತರಿಸಲಾಗಿದೆ',
        'test.instruction_rank': 'ವೀಡಿಯೊವನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ವೀಕ್ಷಿಸಿ. ನಿಮ್ಮ {ordinal} ಆಯ್ಕೆಯನ್ನು ಆರಿಸಿ',
        'test.rank_1st': '1ನೇ',
        'test.rank_2nd': '2ನೇ',
        'test.rank_3rd': '3ನೇ',
        'test.rank_4th': '4ನೇ',
        'test.ranking_progress': 'ಶ್ರೇಣೀಕರಣ ಪ್ರಗತಿ',
        'test.all_ranked': 'ಎಲ್ಲಾ 4 ಆಯ್ಕೆಗಳನ್ನು ಶ್ರೇಣೀಕರಿಸಲಾಗಿದೆ!',
        'test.already_selected': 'ಈಗಾಗಲೇ {ordinal} ಆಯ್ಕೆಯಾಗಿ ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ',
        'test.please_answer': 'ಮುಂದುವರಿಯುವ ಮೊದಲು ದಯವಿಟ್ಟು ಈ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರಿಸಿ.',
        'test.please_answer_all': 'ಸಲ್ಲಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ.',
        'test.unanswered': '{count} ಉಳಿದಿದೆ',
        'test.submit': 'ಮೌಲ್ಯಮಾಪನ ಸಲ್ಲಿಸಿ',
        'test.submitting': 'ಸಲ್ಲಿಸುತ್ತಿದೆ...',
        'test.stay_on_tab': 'ಮೌಲ್ಯಮಾಪನದ ಸಮಯದಲ್ಲಿ ಈ ಟ್ಯಾಬ್ನಲ್ಲಿಯೇ ಇರಿ',
        'test.photo_capturing': 'ಫೋಟೋ ತೆಗೆಯಲಾಗುತ್ತಿದೆ...',
        'test.photo_captured': 'ಫೋಟೋ ತೆಗೆಯಲಾಗಿದೆ',
        'test.photo_error': 'ಫೋಟೋ ತೆಗೆಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ',
        'test.please_answer': 'ಮುಂದುವರಿಯುವ ಮೊದಲು ದಯವಿಟ್ಟು ಈ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರಿಸಿ.',
        'test.please_answer_all': 'ಸಲ್ಲಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ.',
        'test.unanswered': 'ಉಳಿದಿದೆ',
        'test.stay_on_tab': 'ಮೌಲ್ಯಮಾಪನದ ಸಮಯದಲ್ಲಿ ಈ ಟ್ಯಾಬ್‌ನಲ್ಲಿಯೇ ಇರಿ',
        'test.taking_photo': 'ಪರಿಶೀಲನಾ ಫೋಟೋ ತೆಗೆಯಲಾಗುತ್ತಿದೆ...',
        'test.image_unavailable': 'ಚಿತ್ರ ಲಭ್ಯವಿಲ್ಲ',
        'test.cpm_instruction': 'ಮಾದರಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸುವ ಆಯ್ಕೆಯನ್ನು ಆರಿಸಿ',
        'test.assessment_name_ebcss': 'EBCSS (ವೀಡಿಯೊ)',
        'test.reset': 'ಮರುಹೊಂದಿಸಿ',
        'test.resetting': 'ಮರುಹೊಂದಿಸಲಾಗುತ್ತಿದೆ...',
        'test.reset_tooltip': 'ಈ ಪ್ರಶ್ನೆಗಾಗಿ ಎಲ್ಲಾ ಆಯ್ಕೆಗಳನ್ನು ಮರುಹೊಂದಿಸಿ',
        'test.confirm_reset': 'ಈ ಪ್ರಶ್ನೆಗಾಗಿ ಎಲ್ಲಾ ಶ್ರೇಣೀಕರಣಗಳನ್ನು ಮರುಹೊಂದಿಸುವುದೇ?',
        'test.reset_success': 'ಆಯ್ಕೆಗಳನ್ನು ಮರುಹೊಂದಿಸಲಾಗಿದೆ!',
        'test.reset_error': 'ಆಯ್ಕೆಗಳನ್ನು ಮರುಹೊಂದಿಸಲು ವಿಫಲವಾಗಿದೆ',
        'test.nothing_to_reset': 'ಮರುಹೊಂದಿಸಲು ಯಾವುದೇ ಆಯ್ಕೆಗಳಿಲ್ಲ',

        // ============================================
        // Result / Thank You Page
        // ============================================
        'result.title': 'ಧನ್ಯವಾದಗಳು!',
        'result.subtitle': 'ನಿಮ್ಮ ಮೌಲ್ಯಮಾಪನವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ',
        'result.message': 'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಳನ್ನು ದಾಖಲಿಸಲಾಗಿದೆ. ಮೌಲ್ಯಮಾಪನ ತಂಡವು ನಿಮ್ಮ ಸಲ್ಲಿಕೆಯನ್ನು ಪರಿಶೀಲಿಸುತ್ತದೆ.',
        'result.what_next': 'ಮುಂದೆ ಏನಾಗುತ್ತದೆ?',
        'result.next_step_1': 'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತದೆ',
        'result.next_step_2': 'ಮೌಲ್ಯಮಾಪನ ತಂಡವು ನಿಮ್ಮ ಫಲಿತಾಂಶಗಳನ್ನು ಪರಿಶೀಲಿಸುತ್ತದೆ',
        'result.next_step_3': 'ಮುಂದಿನ ಹಂತಗಳ ಬಗ್ಗೆ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಲಾಗುತ್ತದೆ',
        'result.close': 'ಮುಚ್ಚಿ',
        'result.reference': 'ಉಲ್ಲೇಖ ಐಡಿ: {id}',
        'result.contact': 'ನಿಮಗೆ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳಿದ್ದರೆ, ದಯವಿಟ್ಟು ಮೌಲ್ಯಮಾಪನ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.',

        // ============================================
        'error.PHONE_REQUIRED': 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಅಗತ್ಯವಿದೆ',
        'error.PHONE_INVALID': 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ 10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'error.AADHAR_REQUIRED': 'ಆಧಾರ್ ಸಂಖ್ಯೆ ಅಗತ್ಯವಿದೆ',
        'error.AADHAR_INVALID': 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ 12-ಅಂಕಿಯ ಆಧಾರ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        'error.INVALID_TOKEN': 'ಅಮಾನ್ಯ ಅಥವಾ ಅವಧಿ ಮುಗಿದ ಪರಿಶೀಲನಾ ಲಿಂಕ್',
        'error.AADHAR_IN_USE': 'ಈ ಆಧಾರ್ ಸಂಖ್ಯೆಯನ್ನು ಈಗಾಗಲೇ ಸಕ್ರಿಯ ಮೌಲ್ಯಮಾಪನಕ್ಕಾಗಿ ನೋಂದಾಯಿಸಲಾಗಿದೆ',
        'error.PHONE_IN_USE': 'ಈ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಈಗಾಗಲೇ ಸಕ್ರಿಯ ಮೌಲ್ಯಮಾಪನಕ್ಕಾಗಿ ನೋಂದಾಯಿಸಲಾಗಿದೆ',
        'error.SERVER_ERROR': 'ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',

        // ============================================
        // Verification Page — Error Headers (Kannada)
        // ============================================
        'verify.failed_title': 'ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ',
        'verify.duplicate_title': 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ / ಆಧಾರ್ ಈಗಾಗಲೇ ಬಳಕೆಯಲ್ಲಿದೆ',
        'verify.try_again': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',

        // ============================================
        // Face Verification (Extended - Kannada)
        // ============================================
        'faceverify.camera_access_error': 'ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ. ದಯವಿಟ್ಟು ಕ್ಯಾಮೆರಾ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ.',
        'faceverify.pause_default_reason': 'ಮುಖ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ',
        'faceverify.verify_error_retry': 'ಮುಖ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
        'faceverify.skipped': 'ಪರಿಶೀಲನೆ ಬಿಟ್ಟುಬಿಡಲಾಗಿದೆ',
        'faceverify.test_in_progress': 'ಪರೀಕ್ಷೆ ನಡೆಯುತ್ತಿದೆ',
        'faceverify.verifying': 'ಪರಿಶೀಲಿಸುತ್ತಿದೆ...',
        'faceverify.verify_face': 'ಮುಖ ಪರಿಶೀಲಿಸಿ',
        'faceverify.verify_failed': 'ಮುಖ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ',
        'faceverify.try_again': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        'faceverify.paused_title': 'ಪರೀಕ್ಷೆ ವಿರಾಮಗೊಳಿಸಲಾಗಿದೆ',
        'faceverify.paused_message': 'ಮುಖ ಪರಿಶೀಲನೆ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನೀವು ನೋಂದಾಯಿತ ಅಭ್ಯರ್ಥಿ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.',
        'faceverify.auto_resume': 'ಪರೀಕ್ಷೆ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಮುಂದುವರಿಯುತ್ತದೆ',
        'faceverify.resume_now': 'ಈಗ ಮುಂದುವರಿಸಿ',
        'faceverify.verified': 'ಮುಖ ಪರಿಶೀಲಿಸಲಾಗಿದೆ',

        'test.auto_submitting_in': 'ಸಲ್ಲಿಸಲಾಗುತ್ತದೆ',
        'test.all_answered': 'ಎಲ್ಲಾ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಲಾಗಿದೆ',
        'test.submit_now': 'ಈಗ ಸಲ್ಲಿಸಿ',
        'test.submit_error': 'ಮೌಲ್ಯಮಾಪನ ಸಲ್ಲಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    },

    // ⭐═══════════════════════════════════════════════════════════
    // HINDI (NEW)
    // ⭐═══════════════════════════════════════════════════════════
    hi: {
        // ============================================
        // Common
        // ============================================
        'common.loading': 'लोड हो रहा है...',
        'common.continue': 'जारी रखें',
        'common.submit': 'जमा करें',
        'common.next': 'आगे',
        'common.back': 'पीछे',
        'common.cancel': 'रद्द करें',
        'common.retry': 'फिर से प्रयास करें',
        'common.yes': 'हाँ',
        'common.no': 'नहीं',
        'common.optional': 'वैकल्पिक',
        'common.required': 'आवश्यक',
        'common.error': 'त्रुटि',
        'common.success': 'सफलता',

        // ============================================
        // Phone Verification
        // ============================================
        'verify.title': 'अपनी पहचान सत्यापित करें',
        'verify.subtitle': 'जारी रखने के लिए कृपया अपनी संपर्क जानकारी प्रदान करें',
        'verify.phone_label': 'फ़ोन नंबर',
        'verify.phone_placeholder': '10 अंकों का फ़ोन नंबर दर्ज करें',
        'verify.phone_hint': 'सत्यापन के लिए अपना 10 अंकों का फ़ोन नंबर दर्ज करें',
        'verify.aadhar_label': 'आधार नंबर',
        'verify.aadhar_placeholder': '12 अंकों का आधार नंबर दर्ज करें',
        'verify.aadhar_hint': 'सत्यापन के लिए अपना 12 अंकों का आधार नंबर दर्ज करें',
        'verify.name_label': 'पूरा नाम',
        'verify.name_placeholder': 'अपना पूरा नाम दर्ज करें',
        'verify.age_label': 'आयु',
        'verify.age_placeholder': 'अपनी आयु दर्ज करें',
        'verify.sex_label': 'लिंग',
        'verify.sex_male': 'पुरुष',
        'verify.sex_female': 'महिला',
        'verify.sex_other': 'अन्य',
        'verify.submit': 'सत्यापित करें और जारी रखें',
        'verify.submitting': 'सत्यापित किया जा रहा है...',
        'verify.redirecting': 'पुनः निर्देशित किया जा रहा है...',
        'verify.standard_link_notice': 'यह एक मानक लिंक है। कई उम्मीदवार इसका उपयोग कर सकते हैं।',
        'verify.standard_link_notice2': 'प्रत्येक उम्मीदवार को उनका अपना अद्वितीय मूल्यांकन मिलेगा।',
        'verify.privacy_notice': 'आपका फ़ोन नंबर केवल सत्यापन उद्देश्यों के लिए उपयोग किया जाता है।',
        'verify.one_time_notice': 'यह लिंक प्रति उम्मीदवार एक बार उपयोग के लिए मान्य है।',
        'verify.error_title': 'सत्यापन विफल',
        'verify.error_phone': 'कृपया मान्य 10 अंकों का फ़ोन नंबर दर्ज करें',
        'verify.error_aadhar': 'कृपया मान्य 12 अंकों का आधार नंबर दर्ज करें',
        'verify.error_invalid_link': 'अमान्य या समाप्त सत्यापन लिंक',
        'verify.already_completed_title': 'मूल्यांकन पहले ही पूरा हो चुका है',
        'verify.already_completed_message': 'आपने यह मूल्यांकन पहले ही पूरा कर लिया है। आपकी प्रतिक्रियाएँ दर्ज कर ली गई हैं।',
        'verify.resuming_title': 'आपका सत्र फिर से शुरू हो रहा है',
        'verify.resuming_message': 'वापसी पर स्वागत है! जहाँ आपने छोड़ा था वहीं से जारी रखा जा रहा है...',
        'verify.view_result': 'सारांश देखें',

        // ============================================
        // Demographics Form
        // ============================================
        'demo.title': 'व्यक्तिगत जानकारी',
        'demo.subtitle': 'जारी रखने के लिए कृपया अपना विवरण भरें',
        'demo.submit': 'जारी रखें',
        'demo.submitting': 'जमा किया जा रहा है...',
        'demo.required_missing': 'कृपया सभी आवश्यक फ़ील्ड भरें',

        // Field Labels (Hindi)
        'demo.field.full_name': 'पूरा नाम',
        'demo.field.date_of_birth': 'जन्म तिथि',
        'demo.field.education': 'शिक्षा',
        'demo.field.sex': 'लिंग',
        'demo.field.address': 'पता',
        'demo.field.email': 'ईमेल',
        'demo.field.phone': 'फ़ोन',
        'demo.field.job_position': 'नौकरी का पद',
        'demo.field.department': 'विभाग',
        'demo.field.passport_no': 'पासपोर्ट नंबर',
        'demo.field.data_usage_consent': 'डेटा उपयोग सहमति',

        // ============================================
        // Sample Video Page
        // ============================================
        'video.title': 'निर्देश',
        'video.subtitle': 'मूल्यांकन प्रारूप को समझने के लिए इस नमूना वीडियो को देखें',
        'video.description': 'कृपया निम्नलिखित वीडियो को ध्यान से देखें। यह मूल्यांकन प्रक्रिया और क्या अपेक्षा करें यह समझाता है।',
        'video.watched': 'निर्देश देखे गए!',
        'video.watch_prompt': 'जारी रखने के लिए वीडियो देखें',
        'video.continue': 'मूल्यांकन के लिए जारी रखें',
        'video.no_video': 'कोई निर्देश वीडियो उपलब्ध नहीं है।',
        'video.drive_error': 'वीडियो लोड होने में विफल। कृपया अपना इंटरनेट कनेक्शन जांचें।',
        'video.progress': 'देखा गया',

        'test.already_ranked_all': '✅ आपने पहले ही सभी 4 विकल्पों को रैंक कर दिया है!',
        'test.already_selected_this_order': 'आपने पहले ही {ordinal} पसंद के लिए चुना है',
        'test.error_saving': 'चयन सहेजने में त्रुटि। कृपया फिर से प्रयास करें।',
        'test.no_options': 'इस आइटम के लिए कोई प्रतिक्रिया विकल्प उपलब्ध नहीं है',
        'test.video_title': 'मूल्यांकन वीडियो',

        // ============================================
        // Photo Capture (Hindi)
        // ============================================
        'photo.title_before': 'अपनी फ़ोटो लें',
        'photo.title_middle': 'मध्य-मूल्यांकन फ़ोटो',
        'photo.title_end': 'अंतिम फ़ोटो',
        'photo.subtitle_before': 'मूल्यांकन शुरू करने से पहले कृपया फ़ोटो लें',
        'photo.subtitle_middle': 'मूल्यांकन जारी रखने के लिए कृपया फ़ोटो लें',
        'photo.subtitle_end': 'जमा करने से पहले कृपया अंतिम फ़ोटो लें',
        'photo.camera_error': 'कैमरा एक्सेस करने में असमर्थ। कृपया कैमरा एक्सेस की अनुमति दें और फिर से प्रयास करें।',
        'photo.camera_not_ready': 'कैमरा तैयार नहीं है। कृपया प्रतीक्षा करें।',
        'photo.captured_success': 'चेहरा फ़ोटो सफलतापूर्वक ली गई!',
        'photo.capture_failed': 'फ़ोटो लेने में विफल',
        'photo.loading_camera': 'कैमरा लोड हो रहा है...',
        'photo.smile': 'मुस्कुराएं!',
        'photo.captured_badge': 'ली गई',
        'photo.take_photo': 'फ़ोटो लें',
        'photo.taking_photo': 'फ़ोटो ली जा रही है...',
        'photo.retry_camera': 'कैमरा फिर से प्रयास करें',
        'photo.retake_photo': 'फ़ोटो फिर से लें',
        'photo.save_photo': 'फ़ोटो सहेजें',
        'photo.saving': 'सहेजा जा रहा है...',
        'photo.tips_title': 'सुझाव:',
        'photo.tip_face_visible': 'सुनिश्चित करें कि आपका चेहरा स्पष्ट रूप से दिखाई दे',
        'photo.tip_look_camera': 'सीधे कैमरे की ओर देखें',
        'photo.tip_countdown': '"फ़ोटो लें" पर क्लिक करने पर 3 सेकंड की उलटी गिनती शुरू होगी',
        'photo.camera_permission_denied': 'कैमरा एक्सेस अस्वीकार कर दिया गया। कृपया अपने ब्राउज़र सेटिंग्स में कैमरा अनुमति सक्षम करें और फिर से प्रयास करें।',
        'photo.camera_not_found': 'इस डिवाइस पर कोई कैमरा नहीं मिला। कृपया कैमरा कनेक्ट करें और फिर से प्रयास करें।',
        'photo.camera_in_use': 'कैमरा पहले से ही किसी अन्य ऐप द्वारा उपयोग किया जा रहा है। कृपया अन्य ऐप बंद करें और फिर से प्रयास करें।',
        'photo.camera_constraints': 'कैमरा आवश्यक शर्तों को पूरा नहीं करता। कृपया कोई अन्य डिवाइस आज़माएं।',
        'photo.camera_insecure': 'कैमरे के लिए सुरक्षित कनेक्शन (HTTPS) आवश्यक है। कृपया इस पेज को HTTPS पर एक्सेस करें।',
        'photo.camera_not_supported': 'कैमरा समर्थित नहीं है। कृपया HTTPS पर आधुनिक ब्राउज़र का उपयोग करें।',
        'photo.permission_blocked_title': 'कैमरा एक्सेस अवरुद्ध',
        'photo.permission_blocked_message': 'आपने कैमरा एक्सेस अस्वीकार कर दिया है। इस सत्यापन चरण को जारी रखने के लिए, कृपया अपने ब्राउज़र सेटिंग्स में कैमरा अनुमति सक्षम करें।',
        'photo.how_to_enable': 'कैसे सक्षम करें:',
        'photo.enable_step_1': 'अपने ब्राउज़र के एड्रेस बार में लॉक/सेटिंग्स आइकन पर क्लिक करें',
        'photo.enable_step_2': 'कैमरा अनुमति को "अनुमति दें" पर सेट करें',
        'photo.enable_step_3': 'जारी रखने के लिए इस पेज को रीफ्रेश करें',
        'photo.refresh_page': 'पेज रीफ्रेश करें',
        'photo.try_again': 'फिर से प्रयास करें',
        'photo.camera_unavailable_title': 'कैमरा अनुपलब्ध',
        'photo.camera_unavailable_message': 'यह डिवाइस या ब्राउज़र कैमरा एक्सेस का समर्थन नहीं करता। कृपया कोई अन्य डिवाइस या आधुनिक ब्राउज़र आज़माएं।',

        // ============================================
        // Test Page
        // ============================================
        'test.assessment_name': 'EBCSS (वीडियो)',
        'test.resumed': 'फिर से शुरू हुआ',
        'test.progress': 'प्रश्न {current} / {total}',
        'test.answered_count': '{answered} / {total} का उत्तर दिया',
        'test.instruction_rank': 'वीडियो को ध्यान से देखें। अपनी {ordinal} पसंद चुनें',
        'test.rank_1st': 'पहली',
        'test.rank_2nd': 'दूसरी',
        'test.rank_3rd': 'तीसरी',
        'test.rank_4th': 'चौथी',
        'test.ranking_progress': 'रैंकिंग प्रगति',
        'test.all_ranked': 'सभी 4 विकल्पों को रैंक किया गया!',
        'test.already_selected': 'पहले से ही {ordinal} पसंद के रूप में चुना गया',
        'test.please_answer': 'आगे बढ़ने से पहले कृपया इस प्रश्न का उत्तर दें।',
        'test.please_answer_all': 'जमा करने से पहले कृपया सभी प्रश्नों का उत्तर दें।',
        'test.unanswered': '{count} शेष',
        'test.submit': 'मूल्यांकन जमा करें',
        'test.submitting': 'जमा किया जा रहा है...',
        'test.stay_on_tab': 'मूल्यांकन के दौरान इस टैब पर बने रहें',
        'test.photo_capturing': 'फ़ोटो ली जा रही है...',
        'test.photo_captured': 'फ़ोटो ली गई',
        'test.photo_error': 'फ़ोटो नहीं ली जा सकी',
        'test.unanswered': 'शेष',
        'test.taking_photo': 'सत्यापन फ़ोटो ली जा रही है...',
        'test.image_unavailable': 'छवि उपलब्ध नहीं है',
        'test.cpm_instruction': 'वह विकल्प चुनें जो पैटर्न को पूरा करता है',
        'test.assessment_name_ebcss': 'EBCSS (वीडियो)',
        'test.reset': 'रीसेट करें',
        'test.resetting': 'रीसेट किया जा रहा है...',
        'test.reset_tooltip': 'इस प्रश्न के लिए सभी चयन रीसेट करें',
        'test.confirm_reset': 'इस प्रश्न के लिए सभी रैंकिंग रीसेट करें?',
        'test.reset_success': 'चयन रीसेट किए गए!',
        'test.reset_error': 'चयन रीसेट करने में विफल',
        'test.nothing_to_reset': 'रीसेट करने के लिए कोई चयन नहीं',

        // ============================================
        // Result / Thank You Page
        // ============================================
        'result.title': 'धन्यवाद!',
        'result.subtitle': 'आपका मूल्यांकन सफलतापूर्वक जमा कर दिया गया है',
        'result.message': 'आपकी प्रतिक्रियाएँ दर्ज कर ली गई हैं। मूल्यांकन टीम आपके सबमिशन की समीक्षा करेगी।',
        'result.what_next': 'आगे क्या होगा?',
        'result.next_step_1': 'आपकी प्रतिक्रियाओं का विश्लेषण किया जाएगा',
        'result.next_step_2': 'मूल्यांकन टीम आपके परिणामों की समीक्षा करेगी',
        'result.next_step_3': 'अगले कदमों के बारे में आपसे संपर्क किया जाएगा',
        'result.close': 'बंद करें',
        'result.reference': 'संदर्भ आईडी: {id}',
        'result.contact': 'यदि आपके कोई प्रश्न हैं, तो कृपया मूल्यांकन टीम से संपर्क करें।',

        // ============================================
        'error.PHONE_REQUIRED': 'फ़ोन नंबर आवश्यक है',
        'error.PHONE_INVALID': 'कृपया मान्य 10 अंकों का फ़ोन नंबर दर्ज करें',
        'error.AADHAR_REQUIRED': 'आधार नंबर आवश्यक है',
        'error.AADHAR_INVALID': 'कृपया मान्य 12 अंकों का आधार नंबर दर्ज करें',
        'error.INVALID_TOKEN': 'अमान्य या समाप्त सत्यापन लिंक',
        'error.AADHAR_IN_USE': 'यह आधार नंबर पहले से ही एक सक्रिय मूल्यांकन के लिए पंजीकृत है',
        'error.PHONE_IN_USE': 'यह फ़ोन नंबर पहले से ही एक सक्रिय मूल्यांकन के लिए पंजीकृत है',
        'error.SERVER_ERROR': 'कुछ गलत हो गया। कृपया फिर से प्रयास करें।',

        // ============================================
        // Verification Page — Error Headers (Hindi)
        // ============================================
        'verify.failed_title': 'सत्यापन विफल',
        'verify.duplicate_title': 'फ़ोन नंबर / आधार पहले से उपयोग में है',
        'verify.try_again': 'फिर से प्रयास करें',

        // ============================================
        // Face Verification (Extended - Hindi)
        // ============================================
        'faceverify.camera_access_error': 'कैमरा एक्सेस करने में असमर्थ। कृपया कैमरा एक्सेस की अनुमति दें।',
        'faceverify.pause_default_reason': 'चेहरा सत्यापन विफल',
        'faceverify.verify_error_retry': 'चेहरा सत्यापन विफल। कृपया फिर से प्रयास करें।',
        'faceverify.skipped': 'सत्यापन छोड़ा गया',
        'faceverify.test_in_progress': 'परीक्षण चल रहा है',
        'faceverify.verifying': 'सत्यापित किया जा रहा है...',
        'faceverify.verify_face': 'चेहरा सत्यापित करें',
        'faceverify.verify_failed': 'चेहरा सत्यापन विफल',
        'faceverify.try_again': 'फिर से प्रयास करें',
        'faceverify.paused_title': 'परीक्षण रोका गया',
        'faceverify.paused_message': 'चेहरा सत्यापन विफल। कृपया सुनिश्चित करें कि आप पंजीकृत उम्मीदवार हैं।',
        'faceverify.auto_resume': 'परीक्षण स्वचालित रूप से फिर से शुरू होगा',
        'faceverify.resume_now': 'अभी फिर से शुरू करें',
        'faceverify.verified': 'चेहरा सत्यापित',

        'test.auto_submitting_in': 'जमा हो रहा है',
        'test.all_answered': 'सभी प्रश्नों का उत्तर दिया',
        'test.submit_now': 'अभी जमा करें',
        'test.submit_error': 'मूल्यांकन जमा करने में विफल। कृपया फिर से प्रयास करें।',
    }
};

// ============================================
// Translation Helper
// ============================================
export const getTranslation = (language, key, replacements = {}) => {
    const lang = language || 'en';
    const dict = translations[lang] || translations.en;

    let text = dict[key] || translations.en[key] || key;

    // Replace placeholders {name} with values
    Object.entries(replacements).forEach(([placeholder, value]) => {
        text = text.replace(new RegExp(`{${placeholder}}`, 'g'), value);
    });

    return text;
};

// ============================================
// React Hook
// ============================================
import { useContext } from 'react';

export const useTranslation = (language) => {
    return {
        t: (key, replacements) => getTranslation(language, key, replacements),
        language: language || 'en'
    };
};